import produce, { original } from 'immer';
import { combineReducers } from 'redux';

import { debugShowError } from 'Lib/debug';
import type { Action } from 'Lib/reduxType';

import { DELETE_ONBOARDING_SUCCESS, ONBOARDING_INIT } from 'Store/authOnboarding/constants';
import { getCommonResetAction, LOGOUT } from 'Store/commonActions';
import { LOGIN_FAILURE, LOGIN_SUCCESS } from 'Store/mfa/constants';

import { VERIFY_ROUTE, VERIFY_ROUTE_SUCCESS } from './constants';
import initialState from './initialState';
import type { LoadingState } from './types';

const globalLoadingReducer = produce<LoadingState['global'], [Action]>((draft, action) => {
  let counter, newCounter;
  switch (action.type) {
    case LOGOUT:
    case VERIFY_ROUTE:
      draft.loading = true;
      draft.counter = +1;
      break;
    case LOGIN_FAILURE:
    case LOGIN_SUCCESS:
    case VERIFY_ROUTE_SUCCESS:
    case ONBOARDING_INIT:
    case DELETE_ONBOARDING_SUCCESS:
    case getCommonResetAction(action.type): {
      ({ counter } = original(draft) as LoadingState['global']);
      newCounter = counter - 1;
      if (newCounter < 0) {
        debugShowError('Negative loading counter. Underflow.');
      }
      draft.loading = newCounter > 0;
      draft.counter = newCounter;
      break;
    }
    default:
      break;
  }
}, initialState.global);

export const reducer = combineReducers({
  global: globalLoadingReducer,
});
